<div mat-dialog-title class="d-flex justify-content-between align-items-center pt-2" style="padding-bottom: 20px;">
  <div class="prese_heading">
  <h2 class="m-0">New reminder</h2>
  </div>
  <div class="prese_button">
    <button mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>
  </div>
    <mat-dialog-content style="padding-bottom: 0px;">
<div class="reminder-wrapper">
  <!-- Reminder name -->
  <mat-form-field appearance="outline" class="w-100">
    <mat-label>Reminder name</mat-label>
    <input matInput placeholder="Reminder name" />
  </mat-form-field>

  <!-- Trigger date & time -->
  <div class="section">
    <h4>Trigger date and time</h4>
    <div class="chip-row">
      <mat-chip-listbox aria-label="Fish selection">
        <mat-chip color="accent" selected style="background-color: #ffc107;     --mdc-chip-label-text-color: #ffffff;;">February 5, 2026</mat-chip>
        <mat-chip color="accent" selected style="background-color: #ffc107;     --mdc-chip-label-text-color: #ffffff;;">12:00 PM - 01:00 PM</mat-chip>
    </mat-chip-listbox>

    </div>
  </div>

  <!-- Frequency -->
  <div class="section">
    <h4>Frequency</h4>
    <div class="chip-row tmtmt" style="margin-bottom: 20px;">
          <mat-chip-listbox aria-label="Fish selection">
        <mat-chip color="primary" selected>One time</mat-chip>
        <mat-chip color="accent" selected style="background-color: #ffc107;    --mdc-chip-label-text-color: #ffffff;;">Recurring</mat-chip>
    </mat-chip-listbox>
    </div>

      <mat-form-field appearance="outline" class="w-100">
    <mat-label>Frequency interval</mat-label>
    <input matInput placeholder="Reminder name" />
  </mat-form-field>
  </div>

  <!-- Notes -->
   <div class="notifi_case">
  <mat-form-field appearance="outline" class="w-100">
    <mat-label>Notification/notes</mat-label>
    <textarea matInput rows="3"></textarea>
  </mat-form-field>
</div>

</div>
</mat-dialog-content>

 <mat-dialog-actions align="end" style="padding-bottom: 15px;">
    <button mat-button mat-dialog-close>Cancel</button>
    <button  mat-flat-button  color="accent">Create new reminder </button>
  </mat-dialog-actions>